import { render } from "./TransitionVideos.vue?vue&type=template&id=05745d46"
import script from "./TransitionVideos.vue?vue&type=script&lang=js"
export * from "./TransitionVideos.vue?vue&type=script&lang=js"

import "./TransitionVideos.vue?vue&type=style&index=0&id=05745d46&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\siemens-ecdp-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__